import React from "react";
import Helmet from "react-helmet";
import Header from "./header"
import Footer from "./footer"
import {Link} from "react-router-dom"
function TermandUse(){
    return (
        <div>
         <Header />
             <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1545486332-9e0999c535b2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8YmxhY2t8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60)'}}>
  <div className="auto-container">
    <div className="content-box">
      <div className="title">
        <h1>Terms and Conditions</h1>
      </div>
      <ul className="bread-crumb clearfix">
        <li>
            <Link to="/">Home</Link>
        </li>
        
      </ul>
    </div>
  </div>
</section>
       <section className="sidebar-page-container">
  <div className="auto-container">
    <div className="row clearfix">
      <div className="col-lg-12 col-md-12 col-sm-12 content-side">
        <div className="blog-details-content">
          <div className="news-block-one">
            <div className="inner-box">
              <div className="lower-content">
                
                <h2>Terms and Conditionse</h2>
                <div className="text">
                  <p>
Welcome to Gems.com. Gems.com and its affiliates provide their services to you subject to the
following conditions. If you use, visit, or register as a member of the website, you accept these
conditions. Please read them carefully. The Terms of Use are subject to change by Gems.com at
any time, effective upon posting on the Gems.com website, and your use of the Website or the
Service after such posting will constitute acceptance of you of such changes.</p>
 <h3>1. Electronic Agreement</h3>
<p>
This Agreement is an electronic contract that sets out the legally binding terms of your use of
the Website and your membership in the Service. By accessing the website or becoming a
member, you consent to receive communications from us electronically and accept this
agreement and agree to the terms, conditions, notices, and disclosures contained or referenced
herein.
</p>

<h3>2. Privacy</h3>
<p>
Your privacy is very important to us. Use of the Website and/or the Service is also governed by
our Privacy Policy. We designed our Privacy Policy to make important disclosures to you about
how we collect and use the information you post on the Website. Please review it to
understand our practices.
You agree to inform Gems.com your subsequent disability to enter into any contract.
Subsequent, disability shall entitle GemPundit.com to restrict/ change/ terminate this
agreement at its own discretion.</p>
<h3>3. Access to the Site</h3>
<p>Access to the Site is permitted on a temporary basis and we may make changes to the Site from
time to time and may change, suspend or withdraw the content of all or any part of the Site at
any time without notice.</p>
<h3>4. RIGHTS</h3>
<p>All rights in all material and content (including, but not limited to, text, images, web pages,
sound, software (including, code, interface and website structure) and video, and the look and
feel, design and compilation thereof) at this Site are owned by us or our licensors. You may
view this Site and you are welcome to print hard copies of material on it solely for your lawful,
personal, non-commercial use. All other copying, whether in electronic, hard copy or other
format, is prohibited and may breach intellectual property laws and other laws world-wide. You
agree that you are permitted to use this material and/or content only as set out in these Terms 
or as otherwise expressly authorised in writing by us or our licensors, and that you may not
otherwise copy, reproduce, transmit, publicly perform, distribute, commercially exploit, adapt,
translate, modify, bundle, merge, share or make available to any person, or create derivative
works of such material or content or use it for commercial purposes, without our prior written
consent. You may not offer for sale or distribute over any medium, any part of this Site or any
of its content. You shall not interfere or attempt to interfere with the operation or use of Site in
any way through any means or device including, but not limited to, spamming, hacking,
uploading computer viruses or time bombs, or any other means expressly prohibited by any
provision of these Terms.
Please contact customer service with any questions regarding this agreement.

</p>
                </div>
                
              </div>
            </div>
          </div>
       
        </div>
      </div>
    </div>
  </div>
</section>

<Footer />

        </div>
    )
}
export default TermandUse;